import type { SVGProps } from "react";
import { memo } from "react";
const ElasticContainerRegistry = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#C8511B" />
        <stop offset="100%" stopColor="#F90" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M38.788 37.578a1.62 1.62 0 0 0-.802 1.396V66.72L16.999 54.984V27.708l23.558-13.65 20.928 10.37zM63.92 24.402c0-.574-.307-1.11-.86-1.427l-21.714-10.76a1.6 1.6 0 0 0-1.606 0L15.802 26.085A1.62 1.62 0 0 0 15 27.48v27.736c0 .573.308 1.108.817 1.404l21.757 12.165a1.607 1.607 0 0 0 2.41-1.396V39.201l23.134-13.403c.495-.287.802-.821.802-1.396m.05 30.645L44.98 66.661v-10.4l9.901-6.388.068-.449c.018-.117.025-.117.025-.658l.03-12.406L64 31.148zm1.227-25.975a1.6 1.6 0 0 0-1.608 0l-9.575 5.546c-.3.164-1.006.548-1.006 1.34l-.032 12.76-9.125 5.888c-.545.325-.869.84-.869 1.383v11.32c0 .566.305 1.082.816 1.378.267.154.564.232.86.232.29 0 .581-.074.844-.227l19.666-12.028c.494-.288.8-.822.8-1.393L66 30.466c0-.573-.308-1.108-.803-1.394"
      />
    </g>
  </svg>
);
const Memo = memo(ElasticContainerRegistry);
export default Memo;
